// Pure helpers for the TRIAGE_V2 "Back returns to where you came from" rule (no React).
// When a triage route/selector sends the user to another tab, App Shell records where they
// were; Back restores it WITHOUT the arrival-question reset that tapping the Today tab does.
import type { TriageView } from './triageLogic';

export interface JumpReturn { view: TriageView }

/** What to remember when jumping from `fromTab`. Null when the flag is off or the jump
 *  does not start on Today (so the old behaviour is untouched). */
export function captureReturn(enabled: boolean, fromTab: string, view: TriageView): JumpReturn | null {
  return enabled && fromTab === 'today' ? { view } : null;
}

/** The triage view Today should show when restoring after a jump (null = nothing to restore). */
export function restoreView(ret: JumpReturn | null): TriageView | null {
  return ret ? ret.view : null;
}

/** Entering Today fresh (Self-compassion handoff, signed-in user change): the arrival question,
 *  and no recorded jump, so a stale Back target can never send the user to a route they left. */
export function freshTriageNav(): { view: TriageView; returnTo: JumpReturn | null } {
  return { view: 'home', returnTo: null };
}
